module.exports = __webpack_public_path__ + "img/Character_Raiden_Shogun_Thumb.2221d193.png";